import React from 'react';

interface TagProps {
  children: React.ReactNode;
  className?: string;
}

/** A small, non-interactive label such as an article topic or a skill. */
const Tag: React.FC<TagProps> = ({ children, className }) => (
  <span className={['ui-tag', className].filter(Boolean).join(' ')}>{children}</span>
);

export default Tag;
